module.exports = __webpack_public_path__ + "static/media/confused.f9bf068f.png";